import { Component } from '@angular/core';

@Component({
  selector: 'app-angle-right',
  imports: [],
  template: `
    <svg
      width="24"
      height="24"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.51499 9.48044C4.43101 9.47762 4.34848 9.45767 4.27248 9.42182C4.19647 9.38597 4.12859 9.33497 4.073 9.27195C3.95587 9.15468 3.89008 8.99571 3.89008 8.82996C3.89008 8.66421 3.95587 8.50523 4.073 8.38796L6.57487 5.88608L4.073 3.38421C4.02352 3.26411 4.01267 3.13159 4.04193 3.00504C4.0712 2.87849 4.13914 2.76419 4.23633 2.67801C4.33351 2.59183 4.45511 2.53804 4.58425 2.52411C4.7134 2.51019 4.84367 2.53681 4.95699 2.60029L7.87584 5.51914C7.99297 5.63642 8.05877 5.79539 8.05877 5.96114C8.05877 6.12689 7.99297 6.28586 7.87584 6.40314L4.95699 9.27195C4.90139 9.33497 4.83351 9.38597 4.75751 9.42182C4.68151 9.45767 4.59898 9.47762 4.51499 9.48044V9.48044Z"
        fill="#616161"
      />
    </svg>
  `
})
export class AngleRightComponent {}
